import { getMarkRange, mergeAttributes } from "@tiptap/core";
import { Link as TiptapLink } from "@tiptap/extension-link";
import { Plugin, TextSelection } from "@tiptap/pm/state";

import LinkEditPopover from "../../extensions/Link/components/LinkEditPopover";

export const Link = TiptapLink.extend({
	inclusive: false,
	addAttributes() {
		return {
			href: {
				default: null,
			},
			target: {
				default: null,
			},
			rel: {
				default: null,
			},
			class: {
				default: "link",
			},
		};
	},

	parseHTML() {
		return [
			{
				tag: 'a[href]:not([data-type="button"]):not([href *= "javascript:" i])'
			}
		];
	},
	renderHTML({ HTMLAttributes }) {
		const attrs = {
			...HTMLAttributes,
			class: "link",
		};

		if (!HTMLAttributes.target) delete attrs.target;
		if (!HTMLAttributes.rel) delete attrs.rel;

		return ["a", mergeAttributes(attrs), 0];
	},

	addOptions() {
		return {
			...this.parent?.(),
			openOnClick: true,
			button: ({ editor, t }) => {
				return {
					component: LinkEditPopover,
					componentProps: {
						editor,
						action: value => {
							const { link, text, openInNewTab } = value;
							const linkAttrs = {
								href: link,
								class: "link",
							};

							if (openInNewTab) {
								linkAttrs.target = "_blank";
								linkAttrs.rel = "noopener noreferrer";
							}

							if (!openInNewTab) {
								linkAttrs.target = null;
								linkAttrs.rel = null;
							}
							editor
								.chain()
								.extendMarkRange("link")
								.insertContent({
									type: "text",
									text,
									marks: [
										{
											type: "link",
											attrs: linkAttrs,
										}
									]
								})
								.setLink(linkAttrs)
								.focus()
								.run();
						},
						id: "linkk",
						isActive: () => editor.isActive("link") || false,
						icon: "Link",
						tooltip: t("editor.link.tooltip")
					}
				};
			}
		};
	},

	addProseMirrorPlugins() {
		return [
			new Plugin({
				props: {
					handleClick: (view, pos) => {
						const { schema, doc, tr } = view.state;
						const range = getMarkRange(doc.resolve(pos), schema.marks.link);
						if (!range) {
							return false;
						}
						const $start = doc.resolve(range.from);
						const $end = doc.resolve(range.to);
						const transaction = tr.setSelection(new TextSelection($start, $end));
						view.dispatch(transaction);
					}
				}
			})
		];
	}
});
